export const formatRows = (listaItems) => 
  listaItems.map((item, index) => {
    let datosCli;

    try {
      datosCli = JSON.parse(item?.ord_datos_cli || "{}");
    } catch (e) {
      datosCli = {};
    }

    return {
      index: index + 1,
      id: item.ord_id || "Id no disponible",
      cli_name: item?.cli_name
        ? item.cli_name.trim()
        : "Sin Informacion",
      creado: item.ord_server_creation_date ?? "Fecha de creación no disponible",
      procesado: item.createdAt ?? "Fecha de procesamiento no disponible",
      totalpedido: item.monto_total_desc || "0",
      tipocompra: datosCli?.mercadoPago === true ? "Pagado con Mercado Pago" : "Pago en el local",
      observacion: datosCli?.mercadoPago === true ? datosCli : "",
    };
  });
